<template>
  <div class="menu-profile">
    <transition name="fade" mode="out-in">
     
      <div
        class="menu-profile__name"
        @click="openMenu()"
        :data-exclude="true"
        v-if="data.user.fullName"
      >
        {{ data.user.fullName }}
      </div>
    </transition>
    <div class="menu-profile__icon" @click="openMenu()" :data-exclude="true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="4"
        viewBox="0 0 8 4"
      >
        <g fill="none" fill-rule="evenodd">
          <g stroke="#FFF">
            <g>
              <g>
                <path
                  d="M0 0L3.187 3.687 6.373 0"
                  transform="translate(-1295 -47) translate(16 16) translate(1280 31)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <transion name="fade" mode="out-in">
      <div class="menu-profile__nav" v-if="menu" v-click-outside="outside">
        <router-link
          class="menu-profile__nav__item"
          :to="{ name: 'individualProfileEdit' }"
          >Kişisel Bilgiler</router-link
        >
        <div class="menu-profile__nav__item">
          <form-button
            :text="'Oturumu Kapat'"
            @action="logout()"
            :size="'full'"
            :theme="'white'"
            :isDisabled="false" 
          />
        </div>
      </div>
    </transion>
  </div>
</template>

<script>
import { clickOutside } from "@/directives/";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  directives: {
    "click-outside": clickOutside,
  },
  watch: {
    $route() {
      this.outside();
    },
  },
  methods: {
    openMenu: function () {
      this.menu = !this.menu;
    },
    outside: function () {
      this.menu = false;
    },
    logout: function () {
      this.$store.dispatch("logout");
      this.$store
        .dispatch("deletechat")
        .then(() => this.$router.push({ name: "individualLogin" }));
    },
  },
};
</script>